import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BulkSelectEmployeeDialogComponent } from '@app/components';
import { Employee } from '@app/models/employee/employee.model';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { BaseForm } from '@app/modules/forms/base.form';

@Component({
    selector: 'app-employee-select-form',
    templateUrl: './employee-select.form.html',
    styleUrls: ['./employee-select.form.scss'],
})
export class EmployeeSelectForm extends BaseForm {
    @ViewChild('employeeSelect', { static: true }) employeeSelect: BulkSelectEmployeeDialogComponent;
    @Input() additions: Employee[] = [];
    @Input() removals: Employee[] = [];
    @Input() assignedEmployees: Employee[] = [];
    @Input() timeOffPolicy: TimeOffPolicy;
    @Output() changedSelections: EventEmitter<{ additions: Employee[]; removals: Employee[] }> = new EventEmitter<{
        additions: Employee[];
        removals: Employee[];
    }>();

    isLoading = false;

    onEdit(): void {
        this.employeeSelect.show(this.assignedEmployees).then((selectedEmployees: Employee[]) => {
            if (!selectedEmployees) {
                return;
            }
            // Update the list in the view
            this.assignedEmployees = selectedEmployees;

            const originalEmployees: Employee[] = [
                ...this.timeOffPolicy.currentlyAssignedNonTerminatedEmployees,
                ...this.timeOffPolicy.futureAssignedNonTerminatedEmployees,
            ];
            // These will be used throughout the other steps to modify them and form the request payload.
            const removals = [
                ...originalEmployees.filter(
                    (employee: Employee) =>
                        !selectedEmployees.find((selectedEmployee: Employee) => employee.id === selectedEmployee.id)
                ),
            ];

            const additions = [
                ...selectedEmployees.filter(
                    (employee: Employee) =>
                        !originalEmployees.find((originalEmployee: Employee) => employee.id === originalEmployee.id)
                ),
            ];

            this.changedSelections.emit({ additions, removals });
        });
    }
}
